import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../../../hooks/modal/useModal';
import { useRestartPolicyActions } from '../../../../../hooks/settings/restart-policy/useRestartPolicyActions';
import { useWebclient } from '../../../../../hooks/settings/webclients/useWebclient';

export const AddWebclientRestartPolicyWhitelistModal: React.FC = () => {
  const { updateRestartPolicyWhitelist } = useRestartPolicyActions();
  const { webclient } = useWebclient();
  const { t } = useTranslation();

  const { handleSubmit, control } = useForm<{ refParam: string }>({
    shouldUseNativeValidation: true,
    defaultValues: {
      refParam: '',
    },
  });

  const { hideModal } = useModal();

  const hideAndSubmit = ({ refParam }: { refParam: string }) => {
    const restartPolicyWhitelist = [
      ...(webclient?.restartPolicyWhitelist || []),
    ];
    if (!restartPolicyWhitelist.includes(refParam)) {
      restartPolicyWhitelist.push(refParam);
      updateRestartPolicyWhitelist(restartPolicyWhitelist);
    }
    hideModal();
  };

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='text'
              field='refParam'
              placeholder={t('settings.webclient.ref-param.title')}
              label={t('settings.webclient.ref-param.title')}
              id='refParam'
              control={control}
              options={{
                required: t('settings.webclient.validation.ref-param'),
              }}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={hideModal}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.add')}
        </ButtonT>
      </div>
    </form>
  );
};

export default AddWebclientRestartPolicyWhitelistModal;
